/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import {
  IAccount,
  IAccountAPI,
} from '../../interfaces/account/account.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpClient) {}

  createAccount(account: IAccountAPI): Observable<any> {
    return this.http.post(`${getRestEndpoint()}/accounts`, account);
  }

  getAccount(accountNumber: string): Observable<IAccount> {
    return this.http.get<IAccount>(
      `${getRestEndpoint()}/accounts/${accountNumber}`,
    );
  }

  deleteAccount(accountNumber: string): Observable<any> {
    return this.http.delete<any>(
      `${getRestEndpoint()}/accounts/${accountNumber}`,
    );
  }

  editAccount(account: IAccountAPI): Observable<any> {
    const accountNumber: string = account.accountNumber;
    return this.http.put(
      `${getRestEndpoint()}/accounts/${accountNumber}`,
      account,
    );
  }
}

export type IAccountPageParams = {
  limit: number;
  skip: number;
};
